// third-party
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

// project imports
import customerReducer from "./slices/customer";
import contactReducer from "./slices/contact";
import productReducer from "./slices/product";
import chatReducer from "./slices/chat";
import calendarReducer from "./slices/calendar";
import mailReducer from "./slices/mail";

import kanbanReducer from "./slices/kanban";
import userReducer from "./slices/user";
import snackbarReducer from "./slices/snackbar";
import cartReducer from "./slices/cart";
import menuReducer from "./slices/menu";
import accountReducer from "./accountReducer";
import user1Reducer from "./userReducer";
import deptReducer from "./deptReducer";
import settingReducer from "./settingReducer";
import languageReducer from "./languageReducer";
import cmsReducer from "./cmsReducer";
import alertReducer from "./alertReducer";
import propertyReducer from "./propertyReducer";
import rentalAggrementReducer from "./rentalAggrementReducer";
import supportStaffReducer from "./supportStaff";
import staffReplyReducer from "./supportStaffReply";
import propertyRequestChatReducer from "./propertyRequestChatReducer";
import notificationReducer from "./notificationReducer";
import firebaseChatReducer from "./chatReducer";
import reportPropertyReducer from "./reportPropertyReducer";
import appliedPropertyReducer from "./applyPropertyReducer";
import subscriptionReducer from "./SubscriptionReducer";
import tenantReducer from "./tenantReducer";
import analyticsReducer from "./analyticsReducer";
import purchaseAdsReducer from "./purchaseAdsReducer";
import saveOtpReducer from "./otpReducer";
import rentalServiceReducer from "./rentalServiceReducer";
import forgotPasswordReducer from "./slices/forgetPasswordReducer";
import rentalRentReducer from "./rentalRentReducer";
import allPropertyReducer from "./allPropertyReducer";

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  snackbar: snackbarReducer,
  cart: persistReducer(
    {
      key: "cart",
      storage,
      keyPrefix: "berry-",
    },
    cartReducer
  ),
  chat: chatReducer,
  menu: menuReducer,
  auth: accountReducer,
  userAll: user1Reducer,
  departmentAll: deptReducer,
  setting: settingReducer,
  language: languageReducer,
  cms: cmsReducer,
  alert: alertReducer,
  user: userReducer,
  allProperty: allPropertyReducer,
  properties: propertyReducer,
  aggrements: rentalAggrementReducer,
  supportStaffs: supportStaffReducer,
  staffReply: staffReplyReducer,
  propertyRequestChat: propertyRequestChatReducer,
  notifications: notificationReducer,
  chats: firebaseChatReducer,
  reportProperty: reportPropertyReducer,
  appliedProperty: appliedPropertyReducer,
  subscription: subscriptionReducer,
  tenant: tenantReducer,
  analytics: analyticsReducer,
  ads: purchaseAdsReducer,
  saveOtp: saveOtpReducer,
  forgotOtp: forgotPasswordReducer,
  agency: rentalServiceReducer,
  cmsPages: rentalRentReducer,
});

export default reducer;
